import React, { useState } from 'react';
import { MdChat, MdChatBubble } from 'react-icons/md';
import ChatModal from './ChatModal';
import { useTotalUnreadCount } from '../../hooks/useChat';

const ChatButton = ({ user, userRole }) => {
  const [isChatOpen, setIsChatOpen] = useState(false);
  const { totalUnread } = useTotalUnreadCount(user);

  return (
    <>
      <button
        onClick={() => setIsChatOpen(true)}
        style={{
          position: 'fixed',
          bottom: '20px',
          right: '20px',
          width: '60px',
          height: '60px',
          borderRadius: '50%',
          backgroundColor: '#2196f3',
          color: 'white',
          border: 'none',
          cursor: 'pointer',
          boxShadow: '0 4px 12px rgba(33, 150, 243, 0.3)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '24px',
          zIndex: 1000,
          transition: 'all 0.3s ease'
        }}
        onMouseEnter={(e) => {
          e.target.style.transform = 'scale(1.1)';
          e.target.style.boxShadow = '0 6px 16px rgba(33, 150, 243, 0.4)';
        }}
        onMouseLeave={(e) => {
          e.target.style.transform = 'scale(1)';
          e.target.style.boxShadow = '0 4px 12px rgba(33, 150, 243, 0.3)';
        }}
        title="Open Chat"
      >
        <MdChatBubble />
        {totalUnread > 0 && (
          <div style={{
            position: 'absolute',
            top: '-5px',
            right: '-5px',
            backgroundColor: '#f44336',
            color: 'white',
            borderRadius: '50%',
            minWidth: '24px',
            height: '24px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '12px',
            fontWeight: 'bold',
            border: '2px solid white',
            boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
          }}>
            {totalUnread > 99 ? '99+' : totalUnread}
          </div>
        )}
      </button>

      <ChatModal
        isOpen={isChatOpen}
        onClose={() => setIsChatOpen(false)}
        user={user}
        userRole={userRole}
      />
    </>
  );
};

export default ChatButton;
